module.exports = __webpack_public_path__ + "static/media/img-default.84251c7a.png";